import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { SidebarMenuItem } from './SidebarMenuItem';
import { Drawer, DrawerHeader } from './SidebarMenu.styles';
import { navigation } from '../../../utils/core/navigation';
import { useTranslation } from '../../../contexts/translation';
interface Props {
  open: boolean;
  toggleDrawer: () => void;
}

export function SidebarMenu({ open, toggleDrawer }: Props) {
  const { t } = useTranslation();
  const theme = useTheme();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Drawer variant="permanent" open={open}>
      <DrawerHeader>
        <img
          src={'/res/logo/logo-toolbar.svg'}
          alt={'Application logo'}
          title={'Application logo'}
          style={{ width: '50%' }}
        />
        <IconButton onClick={toggleDrawer}>
          {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </DrawerHeader>
      <Divider />
      <List>
        {navigation.map(({ title, path, icon, items }, index) => {
          return (
            <SidebarMenuItem
              id={index}
              key={index}
              name={t(title)}
              location={path}
              icon={icon}
              items={items}
              handleClick={handleClick}
              open={isOpen}
            />
          );
        })}
      </List>
    </Drawer>
  );
}
